/**
 * Wellness nav constants
 */
export const WELLNESS_ITEM_ID = '221'
export const GROVE_WELLNESS_LOGO_IMAGE =
  'https://images.grove.co/upload/f_auto,fl_progressive,w_560,q_auto/global/Logos/Grove-Wellness-Logo.png'
